<template>
  <div class="index" :style="'min-height:'+curHeight+'px;background:#f5f5f5'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games" v-for="(item,i) in advert">
        <a href=""><img :src="baseUrl+item.banner"></a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class="nav">
      <a  @click="$router.push('posters')">
        <img src="~assets/images/ScenicIndex.jpg" >
        好玩
      </a>
      <a  @click="$router.push('read')">
        <img src="~assets/images/BuyCard.jpg" >
        买卡
      </a>
      <a @click="aa">
        <img src="~assets/images/ScanTicket.jpg" >
        绑卡\入园
      </a>
      <a></a>
      <!--<a @click="$router.push('wDetail')">
        <img src="~assets/images/ActivateCard.jpg" >
        激活
      </a>-->
    </div>

    <div class="list">
      <h2>热门景点<a @click="$router.push('posters')">更多</a></h2>
      <ul>
        <li v-for="(item,i) in scenic" @click="toPush(item.id,'postDetail')">
          <div class="title">
            <img :src="baseUrl+item.img[0]" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <!--<font>{{item.read_num}}人听</font>-->
            </div>
          </div>
          <div class="scenceTextInfo">{{item.content}}</div>
        </li>
      </ul>
    </div>

    <div style="height:55px"></div>
    <footComponent :idx='0'></footComponent>
  </div>
</template>

<script>

  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        curHeight:0,
        fullscreenLoading: true,
        page:0,
        advert:[],
        scenic:[],
        baseUrl:'',
        code:''
      };
    },
    beforeMount() {
      /*var aa = {avatar: "https://thirdwx.qlogo.cn/mmopen/vi_32/0uRvTtxDdweS3piaHTLGwL3BymwLmiccTNffVKeFojxyliavEYyu70PkTfISyibcz2DNlhibs1EGLeCUd8yK58hSDKg/132",
        createtime: "2021-05-24",
        id: 8,
        openid: "oQWMowx-WQzE_C-jnDlhlBWsZHpA",
        phone: "",
        username: "Jersey"};*/
       // localStorage.setItem('userjwt', JSON.stringify(aa));
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/write');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }

    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
      this.beforeMount();
      this.getadvert();
      this.getscenic()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      aa:function(){
        window.location.href="http://user.4008005216.com/main/wDetail"
      },

      getadvert:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/index/advert'
        }).then(function(response){
          var res = response.data.data;
          that.advert = res;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      getscenic:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/index/scenic',
          params:{
            page:that.page,
            limit:10
          }
        }).then(function(response){
          var res = response.data.data;
          that.scenic = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
      gggga:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/index/smcode',
        }).then(function(response){
          var result = response.data.data;
          var timestamp = result.timestamp;
          var noncestr = result.nonceStr;
          var signature = result.signature;
          var appId='wxa89a20966e69c2a5';
          wx.config({
            debug : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            //                                debug : true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId : appId, // 必填，公众号的唯一标识
            timestamp : timestamp, // 必填，生成签名的时间戳
            nonceStr : noncestr, // 必填，生成签名的随机串
            signature :signature,// 必填，签名，见附录1
            jsApiList: [
              'scanQRCode'
            ]
          });
          wx.ready(function() {
            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                 
              }
            });
          });
        }).catch(err=>{

        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .index .swiper-slide{
    width:100%
  }
  .index .swiper-slide img{
    display:block;
    width:100%;
  }
  .index .nav{
    display: flex;
    margin: 0 auto;
    flex-wrap: nowrap;
    justify-content: space-between;
    width:100%;
    padding:15px 0;
    background:#fff;
  }
  .index .nav img{
    display:block;
    width:50px;
    margin:3px auto;

  }
  .index .nav a{
    display:block;
    width:25%;
    text-align:center;
    font-size:15px
  }
  .index .list{
    background:#fff;
    margin-top:10px;
  }
  .index .list h2{
    display:block;
    height:45px;
    line-height:45px;
    width:92%;
    margin:0 auto;
    font-size:18px
  }
  .index .list h2:after{
    content:'';
    width:3px;
    height:16px;
    float:left;
    background:#f00;
    margin-top:14px;
    margin-right:8px
  }
  .index .list h2 a{
    float:right;
    color:#666;
    font-size:15px
  }
  .index .list ul{
    display:block;
    width:92%;
    margin:0 auto;
    padding-bottom:1px
  }
  .index .list ul li{
    display:block;
    width:100%;
    margin-bottom:15px
  }
  .index .list ul li .title{
    position:relative;
  }
  .index .list ul li .title img{
    display:block;
    width:100%;
    border-radius:8px
  }
  .index .list ul li .title .conTitle{
    position:absolute;
    bottom:0;
    height:45px;
    background:rgba(0,0,0,.6);
    width:100%;
    border-bottom-right-radius:8px;
    border-bottom-left-radius:8px;
    line-height:45px
  }
  .index .list ul li .title .conTitle span{
    float:left;
    color:#fff;
    margin-left:10px;
    width:60%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    font-size:15px
  }

  .index .list ul li .title .conTitle font{
    float:right;
    color:#007aff;
    width:28%;
    text-align:right;
    padding-right:8px;
    font-size:15px
  }
  .index .list ul li .scenceTextInfo{
    font-size:14px;
    line-height:22px;
    padding-top:8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    letter-spacing:1px;
  }
</style>